import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.scss';
import PhoneAndCodeAPI from '../helpers/PhoneAndCodeAPI';

// Prijavljivanje je zavrseno. Za ponovno otvaranje prijave postaviti na false.
const REGISTRATION_CLOSED = true;

const NewComponent: React.FC = () => {
  const navigate = useNavigate();
  const [isSuccess, setIsSuccess] = useState(false);
  const [formData, setFormData] = useState({
    pfr: '',
    name: '',
    email: '',
    phone: '',
    acceptPrivacy: false,
  });

  const [errors, setErrors] = useState({
    pfr: false,
    name: false,
    email: false,
    phone: false,
    acceptPrivacy: false,
  });

  const [errorMessage, setErrorMessage] = useState('');

  const validate = () => {
    let isValid = true;
    const newErrors = { pfr: false, name: false, email: false, phone: false, acceptPrivacy: false };

    const pfrPattern = /^[A-Za-z0-9]{10}$/;
    if (!formData.pfr || !pfrPattern.test(formData.pfr)) {
      isValid = false;
      newErrors.pfr = true;
    }

    const namePattern = /^[A-Za-z\s]+$/;
    if (!formData.name || !namePattern.test(formData.name)) {
      isValid = false;
      newErrors.name = true;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email || !emailPattern.test(formData.email)) {
      isValid = false;
      newErrors.email = true;
    }

    const phonePattern = /^6\d{7,8}$/;
    if (!formData.phone || !phonePattern.test(formData.phone)) {
      isValid = false;
      newErrors.phone = true;
    }

    if (!formData.acceptPrivacy) {
      isValid = false;
      newErrors.acceptPrivacy = true;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    setErrors({ ...errors, [name]: false });
    setErrorMessage('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (REGISTRATION_CLOSED) return;
    setErrorMessage('');

    if (!validate()) {
      setErrorMessage('Molimo vas da proverite podatke koje ste uneli.');
      return;
    }

    const fullPhone = '+381' + formData.phone;
    const fixedRecaptchaToken = '6LeSRygnAAAAAG2JDpGldjusIALOAVRuBms1hkhG';

    const result = await PhoneAndCodeAPI(
      fullPhone,
      formData.pfr,
      formData.name,
      formData.email,
      fixedRecaptchaToken
    );

    if (result === 201) {
      setFormData((prev) => ({ ...prev, pfr: "" }));
      setErrors({
        pfr: false,
        name: false,
        email: false,
        phone: false,
        acceptPrivacy: false,
      });
      setIsSuccess(true);
    } else if (result === 405) {
      setErrorMessage('Ovaj kod je već iskorišćen.');
    } else if (result === 407) {
      setErrorMessage('Uneti kod ne postoji.');
    } else if (result === 409) {
      setErrorMessage('Broj telefona je označen kao nevažeći.');
    } else {
      setErrorMessage('Došlo je do greške. Pokušajte ponovo.');
    }
  };

  const goToWinners = () => {
    navigate('/');
    setTimeout(() => {
      const target = document.querySelector('#lista-dobitnika');
      if (target) {
        const yOffset = window.innerWidth <= 991 ? -500 : -150;
        const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
    }, 50);
  };

  if (REGISTRATION_CLOSED) {
    return (
      <div className="form-container">
        <div className="form form--thanks">
          <button
            type="button"
            className="form-close"
            onClick={() => navigate('/')}
            aria-label="Zatvori"
          >
            ×
          </button>
          <p className="success-message">
            Hvala svima koji su učestvovali! Prijavljivanje je završeno, a poslednje izvlačenje dobitnika je 12.10.2026. u 13 časova.
          </p>
          <button
            type="button"
            className="submit-button"
            onClick={goToWinners}
          >
            DOBITNICI
          </button>
        </div>
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className="form-container">
        <div className="form form--thanks">
          <button
            type="button"
            className="form-close"
            onClick={() => navigate('/')}
            aria-label="Zatvori"
          >
            ×
          </button>
          <p className="success-message">
            Uspešno ste se prijavili! SAČUVAJTE ZLATNI OTVARAČ! Ako želite unesti novi KOD.
          </p>
          <button
            type="button"
            className="submit-button"
            onClick={() => setIsSuccess(false)}
          >
            PRIJAVI SE
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} className="form" noValidate>
        <button
          type="button"
          className="form-close"
          onClick={() => navigate('/')}
          aria-label="Zatvori"
        >
          ×
        </button>
        <div className="form-field">
          <label htmlFor="pfr">KOD ISPOD OTVARAČA</label>
          <input
            type="text"
            id="pfr"
            name="pfr"
            value={formData.pfr}
            onChange={handleChange}
          />
          {errors.pfr && <p className="error">Nevažeći KOD</p>}
        </div>

        <div className="form-field">
          <label htmlFor="name">IME I PREZIME</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <p className="error">Unesite svoje ime i prezime</p>}
        </div>

        <div className="form-field">
          <label htmlFor="email">E-MAIL ADRESA</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="error">Molimo vas da unesete validnu adresu e-pošte</p>}
        </div>

        <div className="form-field">
          <label htmlFor="phone">BROJ MOBILNOG TELEFONA</label>
          <div className="phone-field">
            <span className="phone-prefix">+381</span>
            <input
              type="text"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="6xxxxxxxx"
              className="phone-input"
            />
          </div>
          {errors.phone && <p className="error">Molimo vas da unesete validan broj telefona</p>}
        </div>

        <div className="privacy">
          <input
            type="checkbox"
            id="acceptPrivacy"
            name="acceptPrivacy"
            checked={formData.acceptPrivacy}
            onChange={handleChange}
          />
          <label htmlFor="acceptPrivacy">
            <a
              href="/zastita-podataka-o-licnosti.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prihvatam politiku privatnosti
            </a>
          </label>
          {errors.acceptPrivacy && (
            <p className="error">Morate prihvatiti politiku privatnosti</p>
          )}
        </div>

        <button type="submit" className="submit-button">PRIJAVI SE</button>

        {errorMessage && (
          <p className={errorMessage.includes('Uspešno') ? 'success-message' : 'error'}>
            {errorMessage}
          </p>
        )}
      </form>
    </div>
  );
};

export default NewComponent;
